import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import notification from "antd/es/notification";
import {
    addDrivercallFailure,
    addDrivercallSuccess,
  getDrivercallFailure,
  getDrivercallSuccess,
} from "../slices/DriverCallSlice";
import { ADD_DRIVERCALL, GET_DRIVERCALL } from "../actions/DriverCallAction";

export function* GetdrivercallSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(getDrivercallSuccess(result.data));
    else {
      yield put(getDrivercallFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(getDrivercallFailure(error.message));
  }
}

export function* AddDrivercallSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    // if (result.status >= 200 && result.status < 300)
    if (result.status == StatusCodes.OK) {
      yield put(addDrivercallSuccess(result.data));
      notification.success({
        message: "Update success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(addDrivercallFailure(result.message));
      notification.error({
        message: "Add Call Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error) {
    yield put(addDrivercallFailure(error));
  }
}

export default function* drivercallSaga() {
  yield all([
    takeLatest(GET_DRIVERCALL, GetdrivercallSaga),
    takeLatest(ADD_DRIVERCALL, AddDrivercallSaga),
  ]);
}
